import React from 'react';
import styles from './AddSection.module.css';
import { useAppDispatch } from 'app/hooks';
import Button from 'components/Button/Button';
import { addPageSection } from 'features/document/documentSlice';
import { ElementType } from 'features/document/constants';
import { Menu, MenuItem } from '@mui/material';

interface Props {
  pageId: string;
  sectionId?: string;
}

const ITEM_HEIGHT = 36.8;

const AddSection: React.FC<Props> = ({ pageId, sectionId }) => {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleAddSection = (elementType: ElementType) => {
    setAnchorEl(null);
    dispatch(
      addPageSection({
        pageId,
        ...(sectionId && { sectionId }),
        type: elementType,
      })
    );
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //  TODO: use MenuButton instead.
  return (
    <div className={`${styles.addSection} ${!open ? styles.sectionHidden : ''}`}>
      <div className={styles.button}>
        <Button
          aria-controls={open ? 'demo-positioned-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          variant='primary'
          onClick={handleClick}
          sx={{ position: 'relative' }}
        >
          + Add Item
        </Button>
        <Menu
          id='add-section-positioned-menu'
          aria-labelledby='add-section-positioned-button'
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          sx={{
            width: '200px',
            marginTop: '8px',
          }}
          slotProps={{
            paper: {
              style: {
                maxHeight: ITEM_HEIGHT * 5,
              },
            },
          }}
        >
          <MenuItem onClick={() => handleAddSection(ElementType.Text)}>Text</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Image)}>Image</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Date)}>Date</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.TextField)}>Text Field</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Spacer)}>Spacer</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Video)}>Video</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Divider)}>Divider</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.CheckBox)}>Checkbox</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.RadioButton)}>Radio Button</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Dropdown)}>Dropdown</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Table)}>Table</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Signature)}>Signature</MenuItem>
          <MenuItem onClick={() => handleAddSection(ElementType.Initials)}>Initials</MenuItem>
        </Menu>
      </div>
      <div className={styles.pointLine} />
    </div>
  );
};

export default AddSection;
